module.exports = __webpack_public_path__ + "static/media/logo-eco-friendly.1a5d1729.png";